(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7343],{

/***/ 51446:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-plugin-framework/[url]",
      function () {
        return __webpack_require__(69985);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cv": function() { return /* reexport */ StructuredData_ArticleSchema; },
  "vd": function() { return /* reexport */ StructuredData_BreadcrumbSchema; },
  "od": function() { return /* reexport */ StructuredData_OrganizationSchema; },
  "zC": function() { return /* reexport */ StructuredData_ProductSchema; },
  "uA": function() { return /* reexport */ StructuredData_SoftwareApplicationSchema; }
});

// UNUSED EXPORTS: StructuredData

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/head.js
var head = __webpack_require__(73917);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/StructuredData/StructuredData.tsx


var StructuredData = function(param) {
    var data = param.data;
    var jsonLd = Array.isArray(data) ? data : [
        data
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: jsonLd.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                // JSON.stringify doesn't escape "</script>" - a field containing
                // that literal string could break out of the script tag and
                // inject arbitrary markup/script into the page.
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(item).replace(/</g, "\\u003c")
                }
            }, index);
        })
    });
};
/* harmony default export */ var StructuredData_StructuredData = (StructuredData);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
;// CONCATENATED MODULE: ./components/StructuredData/OrganizationSchema.tsx
/* provided dependency */ var process = __webpack_require__(82985);



var OrganizationSchema = function(param) {
    var _name = param.name, name = _name === void 0 ? "EPEN Ltd." : _name, _url = param.url, url = _url === void 0 ? "https://vxfx.io" : _url, _logo = param.logo, logo = _logo === void 0 ? "https://vxfx.io/epenfav.webp" : _logo, _description = param.description, description = _description === void 0 ? "EPEN Ltd. is a software company that develops video plugin development frameworks for Adobe Premiere and DaVinci Resolve." : _description, email = param.email, phone = param.phone, address = param.address, _sameAs = param.sameAs, sameAs = _sameAs === void 0 ? [] : _sameAs;
    var siteUrl = process.env.SITE_URL || "https://vxfx.io";
    var organizationSchema = (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: name,
        url: url || siteUrl,
        logo: logo || "".concat(siteUrl, "/epenfav.webp"),
        description: description
    }, email && {
        email: email
    }, phone && {
        telephone: phone
    }, address && {
        address: (0,_object_spread/* default */.Z)({
            "@type": "PostalAddress"
        }, address.streetAddress && {
            streetAddress: address.streetAddress
        }, address.addressLocality && {
            addressLocality: address.addressLocality
        }, address.addressRegion && {
            addressRegion: address.addressRegion
        }, address.postalCode && {
            postalCode: address.postalCode
        }, address.addressCountry && {
            addressCountry: address.addressCountry
        })
    }, sameAs.length > 0 && {
        sameAs: sameAs
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: organizationSchema
    });
};
/* harmony default export */ var StructuredData_OrganizationSchema = (OrganizationSchema);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
;// CONCATENATED MODULE: ./components/StructuredData/ProductSchema.tsx
/* provided dependency */ var ProductSchema_process = __webpack_require__(82985);




var ProductSchema = function(param) {
    var name = param.name, description = param.description, image = param.image, url = param.url, _brand = param.brand, brand = _brand === void 0 ? "EPEN Ltd." : _brand, sku = param.sku, offers = param.offers, aggregateRating = param.aggregateRating;
    var siteUrl = ProductSchema_process.env.SITE_URL || "https://vxfx.io";
    var productUrl = url || "".concat(siteUrl, "/video-plugin-framework/").concat(name.toLowerCase().replace(/\s+/g, "-"));
    var productImage = image || "".concat(siteUrl, "/epenfav.webp");
    var productSchema = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "Product",
        name: name
    }, description && {
        description: description
    }), {
        image: Array.isArray(image) ? image : [
            productImage
        ],
        url: productUrl,
        brand: {
            "@type": "Brand",
            name: brand
        }
    }), sku && {
        sku: sku
    }, offers && {
        offers: (0,_object_spread/* default */.Z)({
            "@type": "Offer"
        }, offers.price && {
            price: offers.price
        }, offers.priceCurrency && {
            priceCurrency: offers.priceCurrency
        }, offers.availability && {
            availability: "https://schema.org/".concat(offers.availability)
        }, offers.url && {
            url: offers.url
        })
    }, aggregateRating && {
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: aggregateRating.ratingValue,
            reviewCount: aggregateRating.reviewCount
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: productSchema
    });
};
/* harmony default export */ var StructuredData_ProductSchema = (ProductSchema);

;// CONCATENATED MODULE: ./components/StructuredData/ArticleSchema.tsx
/* provided dependency */ var ArticleSchema_process = __webpack_require__(82985);




var ArticleSchema = function(param) {
    var headline = param.headline, description = param.description, image = param.image, datePublished = param.datePublished, dateModified = param.dateModified, author = param.author, _publisher = param.publisher, publisher = _publisher === void 0 ? {
        name: "EPEN Ltd.",
        logo: "https://vxfx.io/epenfav.webp"
    } : _publisher, url = param.url;
    var siteUrl = ArticleSchema_process.env.SITE_URL || "https://vxfx.io";
    var articleUrl = url || "".concat(siteUrl, "/news/").concat(headline.toLowerCase().replace(/\s+/g, "-"));
    var articleImage = image || "".concat(siteUrl, "/epenfav.webp");
    var articleSchema = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "Article",
        headline: headline
    }, description && {
        description: description
    }), {
        image: Array.isArray(image) ? image : [
            articleImage
        ],
        datePublished: datePublished
    }), dateModified && {
        dateModified: dateModified
    }, author && {
        author: (0,_object_spread/* default */.Z)({
            "@type": "Person",
            name: author.name
        }, author.url && {
            url: author.url
        })
    }), {
        publisher: {
            "@type": "Organization",
            name: publisher.name,
            logo: {
                "@type": "ImageObject",
                url: publisher.logo || "".concat(siteUrl, "/epenfav.webp")
            }
        },
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": articleUrl
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: articleSchema
    });
};
/* harmony default export */ var StructuredData_ArticleSchema = (ArticleSchema);

;// CONCATENATED MODULE: ./components/StructuredData/BreadcrumbSchema.tsx
/* provided dependency */ var BreadcrumbSchema_process = __webpack_require__(82985);


var BreadcrumbSchema = function(param) {
    var items = param.items;
    var siteUrl = BreadcrumbSchema_process.env.SITE_URL || "https://vxfx.io";
    var breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map(function(item, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: item.name,
                item: item.url.startsWith("http") ? item.url : "".concat(siteUrl).concat(item.url)
            };
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: breadcrumbSchema
    });
};
/* harmony default export */ var StructuredData_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/StructuredData/SoftwareApplicationSchema.tsx
/* provided dependency */ var SoftwareApplicationSchema_process = __webpack_require__(82985);




var SoftwareApplicationSchema = function(param) {
    var _name = param.name, name = _name === void 0 ? "VxFx" : _name, _description = param.description, description = _description === void 0 ? "Universal video plugin framework supporting Windows, macOS, and Linux. GPU-accelerated with CUDA, OpenCL, Metal, and DirectX." : _description, image = param.image, _operatingSystem = param.operatingSystem, operatingSystem = _operatingSystem === void 0 ? "Windows, macOS, Linux" : _operatingSystem, _applicationCategory = param.applicationCategory, applicationCategory = _applicationCategory === void 0 ? "MultimediaApplication" : _applicationCategory, offers = param.offers;
    var siteUrl = SoftwareApplicationSchema_process.env.SITE_URL || "https://vxfx.io";
    var schema = (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        name: name,
        description: description,
        image: image || "".concat(siteUrl, "/epenfav.webp"),
        operatingSystem: operatingSystem,
        applicationCategory: applicationCategory,
        url: siteUrl
    }, offers && {
        offers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "@type": "Offer"
        }, offers.price && {
            price: offers.price
        }), {
            priceCurrency: offers.priceCurrency || "USD"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: schema
    });
};
/* harmony default export */ var StructuredData_SoftwareApplicationSchema = (SoftwareApplicationSchema);

;// CONCATENATED MODULE: ./components/StructuredData/index.ts








/***/ }),

/***/ 69985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55716);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_Header_Header__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50959);
/* harmony import */ var _components_SEO__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38743);
/* harmony import */ var _components_StructuredData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55306);
/* harmony import */ var _data_keywords__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83075);
/* provided dependency */ var process = __webpack_require__(82985);








// Lazy load components below the fold for better initial page load
var BookPageHome = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(762), __webpack_require__.e(6399), __webpack_require__.e(9585), __webpack_require__.e(9541)]).then(__webpack_require__.bind(__webpack_require__, 82324));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82324)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                minHeight: "600px"
            }
        });
    }
});
var DrivingInnovation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 7704).then(__webpack_require__.bind(__webpack_require__, 67704));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67704)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                minHeight: "400px"
            }
        });
    }
});
var LicensingOptions = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3053), __webpack_require__.e(762), __webpack_require__.e(6399), __webpack_require__.e(5119), __webpack_require__.e(5219), __webpack_require__.e(5166), __webpack_require__.e(7955), __webpack_require__.e(5754)]).then(__webpack_require__.bind(__webpack_require__, 30484));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30484)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                minHeight: "300px"
            }
        });
    }
});
var KeyMain = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6399), __webpack_require__.e(6322)]).then(__webpack_require__.bind(__webpack_require__, 56322));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56322)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                minHeight: "400px"
            }
        });
    }
});
var DevelopersChoose = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6399), __webpack_require__.e(4645)]).then(__webpack_require__.bind(__webpack_require__, 24645));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24645)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                minHeight: "300px"
            }
        });
    }
});
var HowWork = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6399), __webpack_require__.e(3688)]).then(__webpack_require__.bind(__webpack_require__, 33688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33688)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                minHeight: "400px"
            }
        });
    }
});
var ProductFAQ = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3053), __webpack_require__.e(7475)]).then(__webpack_require__.bind(__webpack_require__, 72070));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72070)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                minHeight: "300px"
            }
        });
    }
});
var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8030), __webpack_require__.e(6309), __webpack_require__.e(9495)]).then(__webpack_require__.bind(__webpack_require__, 83767));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83767)
            ];
        }
    }
});
var BookPage = function(param) {
    var productData = param.productData, aboutData = param.aboutData, categories = param.categories, faqs = param.faqs;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!router.isReady) return;
        var scrollTarget = router.query.scroll;
        if (!scrollTarget) return;
        var performScroll = function() {
            var element = document.getElementById(scrollTarget);
            if (element) {
                var offset = 165;
                var elementPosition = element.getBoundingClientRect().top + window.scrollY;
                var offsetPosition = elementPosition - offset;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
                return true;
            }
            return false;
        };
        // Try immediately
        if (performScroll()) return;
        // Retry mechanism - element might not be rendered yet
        var retries = 0;
        var maxRetries = 20;
        var retryInterval = 200;
        var tryScroll = function() {
            if (performScroll()) return;
            if (retries < maxRetries) {
                retries++;
                setTimeout(tryScroll, retryInterval);
            }
        };
        setTimeout(tryScroll, retryInterval);
    }, [
        router.isReady,
        router.query.scroll
    ]);
    var siteUrl = process.env.SITE_URL || "https://vxfx.io";
    var productImage = (productData === null || productData === void 0 ? void 0 : (ref = productData.image) === null || ref === void 0 ? void 0 : ref.url) || "".concat(siteUrl, "/epenfav.webp");
    // Create optimized description with call-to-action
    var productDescription = (productData === null || productData === void 0 ? void 0 : productData.description) || (productData === null || productData === void 0 ? void 0 : productData.name) || "";
    if (productDescription && productDescription.length > 120) {
        var truncated = productDescription.substring(0, 120).trim();
        var lastSpace = truncated.lastIndexOf(" ");
        productDescription = lastSpace > 100 ? "".concat(truncated.substring(0, lastSpace), "... Discover more!") : "".concat(truncated, "... Get started today!");
    } else if (productDescription && productDescription.length < 100) {
        productDescription = "".concat(productDescription, " Professional video plugin solution. Explore features and pricing now!");
    }
    // Get optimized keywords for the product
    var productKeywords = (productData === null || productData === void 0 ? void 0 : productData.name) ? (0,_data_keywords__WEBPACK_IMPORTED_MODULE_7__/* .getProductKeywords */ .DK)(productData.name, productData === null || productData === void 0 ? void 0 : productData.category) : null;
    var keywordsString = productKeywords ? (0,_data_keywords__WEBPACK_IMPORTED_MODULE_7__/* .formatKeywords */ .zh)(productKeywords) : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: (productData === null || productData === void 0 ? void 0 : productData.name) || "Product",
                description: productDescription,
                image: productImage,
                type: "product",
                keywords: keywordsString
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StructuredData__WEBPACK_IMPORTED_MODULE_6__/* .ProductSchema */ .zC, {
                name: (productData === null || productData === void 0 ? void 0 : productData.name) || "Product",
                description: productDescription,
                image: productImage,
                url: "".concat(siteUrl, "/video-plugin-framework/").concat(router.query.url),
                brand: "EPEN Ltd.",
                sku: productData === null || productData === void 0 ? void 0 : productData._id
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StructuredData__WEBPACK_IMPORTED_MODULE_6__/* .BreadcrumbSchema */ .vd, {
                items: [
                    {
                        name: "Home",
                        url: "/"
                    },
                    {
                        name: "Products",
                        url: "/video-plugin-framework"
                    },
                    {
                        name: (productData === null || productData === void 0 ? void 0 : productData.name) || "Product",
                        url: "/video-plugin-framework/".concat(router.query.url)
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Header_Header__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookPageHome, {
                    data: productData
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DrivingInnovation, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LicensingOptions, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(KeyMain, {
                    data: productData
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DevelopersChoose, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HowWork, {
                    data: productData
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductFAQ, {
                categories: categories,
                faqs: faqs
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {
                aboutData: aboutData
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (BookPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3977,6538,6607,3167,2033,5304,9774,2888,179], function() { return __webpack_exec__(51446); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);